@if (canShowBulkButton()) {
  <div class="app-round-button-mv action" data-cy="grid-engine-call-to-action-header" fxLayoutAlign="center center">
    @let ctActions = bulkActions();
    @if (isCallToActionVisible() && ctActions?.length) {
      @if (ctActions?.length === 1 && ctActions[0]?.displaySingleAction) {
        <button
          (click)="$event.stopPropagation(); onBulkActionClick(ctActions[0].key)"
          [matTooltip]="$safeNavigationMigration(ctActions[0]?.label) | translate | uppercase"
          matTooltipClass="regular-tooltip"
          matTooltipPosition="below"
          color="accent"
          mat-icon-button
        >
          <mat-icon>{{ ctActions[0].icon }}</mat-icon>
        </button>
      } @else {
        <button (click)="$event.preventDefault(); $event.stopPropagation()" [matMenuTriggerFor]="menu" color="accent" mat-icon-button>
          <mat-icon>more_vert</mat-icon>
        </button>
      }
    }
    <mat-menu #menu="matMenu">
      @for (action of ctActions; track $index) {
        @if (action?.divider) {
          <mat-divider></mat-divider>
        }
        <div fxLayout="row" fxLayoutAlign="space-between center">
          @if (bulkActionVisibility()?.[action.key]) {
            <button (click)="onBulkActionClick(action.key)" mat-menu-item>
              {{ action.label | translate | uppercase }}
            </button>
          }
        </div>
      }
    </mat-menu>
  </div>
}
